// Get Contract List

export const GET_CONTRACT_LIST = "GET_CONTRACT_LIST";
export const GET_CONTRACT_LIST_SUCCESS = "GET_CONTRACT_LIST_SUCCESS";
export const GET_CONTRACT_LIST_FAILURE = "GET_CONTRACT_LIST_FAILURE";

// Create New Contract Item

export const CREATE_CONTRACT_ITEM = "CREATE_CONTRACT_ITEM";
export const CREATE_CONTRACT_ITEM_SUCCESS = "CREATE_CONTRACT_ITEM_SUCCESS";
export const CREATE_CONTRACT_ITEM_FAILURE = "CREATE_CONTRACT_ITEM_FAILURE";

// Get Contract Status List

export const GET_CONTRACT_STATUS_LIST = "GET_CONTRACT_STATUS_LIST";
export const GET_CONTRACT_STATUS_LIST_SUCCESS =
  "GET_CONTRACT_STATUS_LIST_SUCCESS";
export const GET_CONTRACT_STATUS_LIST_FAILURE =
  "GET_CONTRACT_STATUS_LIST_FAILURE";

// Get Single Contract Item

export const GET_SINGLE_CONTRACT_ITEM = "GET_SINGLE_CONTRACT_ITEM";
export const GET_SINGLE_CONTRACT_ITEM_SUCCESS =
  "GET_SINGLE_CONTRACT_ITEM_SUCCESS";
export const GET_SINGLE_CONTRACT_ITEM_FAILURE =
  "GET_SINGLE_CONTRACT_ITEM_FAILURE";

// Update Contract Item

export const UPDATE_CONTRACT_ITEM = "UPDATE_CONTRACT_ITEM";
export const UPDATE_CONTRACT_ITEM_SUCCESS = "UPDATE_CONTRACT_ITEM_SUCCESS";
export const UPDATE_CONTRACT_ITEM_FAILURE = "UPDATE_CONTRACT_ITEM_FAILURE";

// Delete Cotracts

export const DELETE_CONTRACT_ITEMS = "DELETE_CONTRACT_ITEMS";
export const DELETE_CONTRACT_ITEMS_SUCCESS = "DELETE_CONTRACT_ITEMS_SUCCESS";
export const DELETE_CONTRACT_ITEMS_FAILURE = "DELETE_CONTRACT_ITEMS_FAILURE";

// Search Contracts
export const SINGLE_CUSTOMER_SEARCH_CONTRACTS =
  "SINGLE_CUSTOMER_SEARCH_CONTRACTS";
export const SINGLE_CUSTOMER_SEARCH_CONTRACTS_SUCCESS =
  "SINGLE_CUSTOMER_SEARCH_CONTRACTS_SUCCESS";
export const SINGLE_CUSTOMER_SEARCH_CONTRACTS_FAILURE =
  "SINGLE_CUSTOMER_SEARCH_CONTRACTS_FAILURE";

// Contract Items List

export const GET_CONTRACT_ITEMS_LIST = "GET_CONTRACT_ITEMS_LIST";
export const GET_CONTRACT_ITEMS_LIST_SUCCESS =
  "GET_CONTRACT_ITEMS_LIST_SUCCESS";
export const GET_CONTRACT_ITEMS_LIST_FAILURE =
  "GET_CONTRACT_ITEMS_LIST_FAILURE";

// Get Contract Items Status List

export const GET_CONTRACT_ITEMS_STATUS_LIST = "GET_CONTRACT_ITEMS_STATUS_LIST";
export const GET_CONTRACT_ITEMS_STATUS_LIST_SUCCESS =
  "GET_CONTRACT_ITEMS_STATUS_LIST_SUCCESS";
export const GET_CONTRACT_ITEMS_STATUS_LIST_FAILURE =
  "GET_CONTRACT_ITEMS_STATUS_LIST_FAILURE";

// Contract Unit Frequency List

export const GET_CONTRACT_UNIT_FREQUENCY_LIST =
  "GET_CONTRACT_UNIT_FREQUENCY_LIST";
export const GET_CONTRACT_UNIT_FREQUENCY_LIST_SUCCESS =
  "GET_CONTRACT_UNIT_FREQUENCY_LIST_SUCCESS";
export const GET_CONTRACT_UNIT_FREQUENCY_LIST_FAILURE =
  "GET_CONTRACT_UNIT_FREQUENCY_LIST_FAILURE";

// Single Customer Contract Item List

export const GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST =
  "GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST";
export const GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_SUCCESS =
  "GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_SUCCESS";
export const GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_FAILURE =
  "GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_FAILURE";

// Create Contract with Items

export const CREATE_CONTRACT_WITH_ITEMS = "CREATE_CONTRACT_WITH_ITEMS";
export const CREATE_CONTRACT_WITH_ITEMS_SUCCESS =
  "CREATE_CONTRACT_WITH_ITEMS_SUCCESS";
export const CREATE_CONTRACT_WITH_ITEMS_FAILURE =
  "CREATE_CONTRACT_WITH_ITEMS_FAILURE";

// Single Customer Contract Item List Summary

export const GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_SUMMARY =
  "GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_SUMMARY";

export const GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_SUMMARY_SUCCESS =
  "GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_SUMMARY_SUCCESS";

export const GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_SUMMARY_FAILURE =
  "GET_SINGLE_CUSTOMER_CONTRACT_ITEMS_LIST_SUMMARY_FAILURE";

// Update Contract with Items

export const UPDATE_CONTRACT_WITH_ITEMS = "UPDATE_CONTRACT_WITH_ITEMS";
export const UPDATE_CONTRACT_WITH_ITEMS_SUCCESS =
  "UPDATE_CONTRACT_WITH_ITEMS_SUCCESS";
export const UPDATE_CONTRACT_WITH_ITEMS_FAILURE =
  "UPDATE_CONTRACT_WITH_ITEMS_FAILURE";

// Preview Contract Update (dry-run)

export const PREVIEW_CONTRACT_UPDATE = "PREVIEW_CONTRACT_UPDATE";
export const PREVIEW_CONTRACT_UPDATE_SUCCESS =
  "PREVIEW_CONTRACT_UPDATE_SUCCESS";
export const PREVIEW_CONTRACT_UPDATE_FAILURE =
  "PREVIEW_CONTRACT_UPDATE_FAILURE";

// Preview Contract Create (dry-run)
export const PREVIEW_CONTRACT_CREATE = "PREVIEW_CONTRACT_CREATE";
export const PREVIEW_CONTRACT_CREATE_SUCCESS =
  "PREVIEW_CONTRACT_CREATE_SUCCESS";
export const PREVIEW_CONTRACT_CREATE_FAILURE =
  "PREVIEW_CONTRACT_CREATE_FAILURE";

// Contract item Renewal Frequency

export const GET_CONTRACT_ITEM_RENEWAL_FREQUENCY_LIST =
  "GET_CONTRACT_ITEM_RENEWAL_FREQUENCY_LIST";
export const GET_CONTRACT_ITEM_RENEWAL_FREQUENCY_LIST_SUCCESS =
  "GET_CONTRACT_ITEM_RENEWAL_FREQUENCY_LIST_SUCCESS";
export const GET_CONTRACT_ITEM_RENEWAL_FREQUENCY_LIST_FAILURE =
  "GET_CONTRACT_ITEM_RENEWAL_FREQUENCY_LIST_FAILURE";

// delete single contract item
export const DELETE_SINGLE_CONTRACT_ITEM = "DELETE_SINGLE_CONTRACT_ITEM";
export const DELETE_SINGLE_CONTRACT_ITEM_SUCCESS =
  "DELETE_SINGLE_CONTRACT_ITEM_SUCCESS";
export const DELETE_SINGLE_CONTRACT_ITEM_FAILURE =
  "DELETE_SINGLE_CONTRACT_ITEM_FAILURE";

// Contract Items Active List
export const GET_CONTRACT_ITEMS_ACTIVE_LIST = "GET_CONTRACT_ITEMS_ACTIVE_LIST";
export const GET_CONTRACT_ITEMS_ACTIVE_LIST_SUCCESS =
  "GET_CONTRACT_ITEMS_ACTIVE_LIST_SUCCESS";
export const GET_CONTRACT_ITEMS_ACTIVE_LIST_FAILURE =
  "GET_CONTRACT_ITEMS_ACTIVE_LIST_FAILURE";

// Contract Items Cancelled List
export const GET_CONTRACT_ITEMS_CANCELLED_LIST =
  "GET_CONTRACT_ITEMS_CANCELLED_LIST";
export const GET_CONTRACT_ITEMS_CANCELLED_LIST_SUCCESS =
  "GET_CONTRACT_ITEMS_CANCELLED_LIST_SUCCESS";
export const GET_CONTRACT_ITEMS_CANCELLED_LIST_FAILURE =
  "GET_CONTRACT_ITEMS_CANCELLED_LIST_FAILURE";

///contractitemusage/search
export const GET_CONTRACT_ITEM_USAGE_SEARCH_LIST =
  "GET_CONTRACT_ITEM_USAGE_SEARCH_LIST";
export const GET_CONTRACT_ITEM_USAGE_SEARCH_LIST_SUCCESS =
  "GET_CONTRACT_ITEM_USAGE_SEARCH_LIST_SUCCESS";
export const GET_CONTRACT_ITEM_USAGE_SEARCH_LIST_FAILURE =
  "GET_CONTRACT_ITEM_USAGE_SEARCH_LIST_FAILURE";

//contractitemusage/list
export const GET_CONTRACT_ITEM_USAGE_LIST = "GET_CONTRACT_ITEM_USAGE_LIST";
export const GET_CONTRACT_ITEM_USAGE_LIST_SUCCESS =
  "GET_CONTRACT_ITEM_USAGE_LIST_SUCCESS";
export const GET_CONTRACT_ITEM_USAGE_LIST_FAILURE =
  "GET_CONTRACT_ITEM_USAGE_LIST_FAILURE";

//contractitemusage/search
export const GET_CONTRACT_ITEM_USAGE_SEARCH = "GET_CONTRACT_ITEM_USAGE_SEARCH";
export const GET_CONTRACT_ITEM_USAGE_SEARCH_SUCCESS =
  "GET_CONTRACT_ITEM_USAGE_SEARCH_SUCCESS";
export const GET_CONTRACT_ITEM_USAGE_SEARCH_FAILURE =
  "GET_CONTRACT_ITEM_USAGE_SEARCH_FAILURE";

///contract/pdfcontractsheet
export const SEARCH_CONTRACT_PDF = "SEARCH_CONTRACT_PDF";
export const SEARCH_CONTRACT_PDF_SUCCESS = "SEARCH_CONTRACT_PDF_SUCCESS";
export const SEARCH_CONTRACT_PDF_FAILURE = "SEARCH_CONTRACT_PDF_FAILURE";

///contractitemusage/delete/allprevious
export const DELETE_ALL_PREVIOUS_CONTRACT_ITEM_USAGE =
  "DELETE_ALL_PREVIOUS_CONTRACT_ITEM_USAGE";
export const DELETE_ALL_PREVIOUS_CONTRACT_ITEM_USAGE_SUCCESS =
  "DELETE_ALL_PREVIOUS_CONTRACT_ITEM_USAGE_SUCCESS";
export const DELETE_ALL_PREVIOUS_CONTRACT_ITEM_USAGE_FAILURE =
  "DELETE_ALL_PREVIOUS_CONTRACT_ITEM_USAGE_FAILURE";
///contractitemusage/livebalance/pdf
export const GET_CONTRACT_ITEM_USAGE_LIVE_BALANCE_PDF =
  "GET_CONTRACT_ITEM_USAGE_LIVE_BALANCE_PDF";
export const GET_CONTRACT_ITEM_USAGE_LIVE_BALANCE_PDF_SUCCESS =
  "GET_CONTRACT_ITEM_USAGE_LIVE_BALANCE_PDF_SUCCESS";
export const GET_CONTRACT_ITEM_USAGE_LIVE_BALANCE_PDF_FAILURE =
  "GET_CONTRACT_ITEM_USAGE_LIVE_BALANCE_PDF_FAILURE";

///contractitemusage/generate
export const GENERATE_CONTRACT_ITEM_USAGE = "GENERATE_CONTRACT_ITEM_USAGE";
export const GENERATE_CONTRACT_ITEM_USAGE_SUCCESS =
  "GENERATE_CONTRACT_ITEM_USAGE_SUCCESS";
export const GENERATE_CONTRACT_ITEM_USAGE_FAILURE =
  "GENERATE_CONTRACT_ITEM_USAGE_FAILURE";

///contractitemusage/pdf/(:num)
export const GET_CONTRACT_ITEM_USAGE_PDF = "GET_CONTRACT_ITEM_USAGE_PDF";
export const GET_CONTRACT_ITEM_USAGE_PDF_SUCCESS =
  "GET_CONTRACT_ITEM_USAGE_PDF_SUCCESS";
export const GET_CONTRACT_ITEM_USAGE_PDF_FAILURE =
  "GET_CONTRACT_ITEM_USAGE_PDF_FAILURE";

///contractitemusage/pdfregenerate/(:num)
export const REGENERATE_CONTRACT_ITEM_USAGE_PDF =
  "REGENERATE_CONTRACT_ITEM_USAGE_PDF";
export const REGENERATE_CONTRACT_ITEM_USAGE_PDF_SUCCESS =
  "REGENERATE_CONTRACT_ITEM_USAGE_PDF_SUCCESS";
export const REGENERATE_CONTRACT_ITEM_USAGE_PDF_FAILURE =
  "REGENERATE_CONTRACT_ITEM_USAGE_PDF_FAILURE";

///contractitemcredit/list/(:num)
export const GET_CONTRACT_ITEM_CREDIT_LIST = "GET_CONTRACT_ITEM_CREDIT_LIST";
export const GET_CONTRACT_ITEM_CREDIT_LIST_SUCCESS =
  "GET_CONTRACT_ITEM_CREDIT_LIST_SUCCESS";
export const GET_CONTRACT_ITEM_CREDIT_LIST_FAILURE =
  "GET_CONTRACT_ITEM_CREDIT_LIST_FAILURE";

///contractitemcredit/create
export const CREATE_CONTRACT_ITEM_CREDIT = "CREATE_CONTRACT_ITEM_CREDIT";
export const CREATE_CONTRACT_ITEM_CREDIT_SUCCESS =
  "CREATE_CONTRACT_ITEM_CREDIT_SUCCESS";
export const CREATE_CONTRACT_ITEM_CREDIT_FAILURE =
  "CREATE_CONTRACT_ITEM_CREDIT_FAILURE";

///contractitemcredit/update
export const UPDATE_CONTRACT_ITEM_CREDIT = "UPDATE_CONTRACT_ITEM_CREDIT";
export const UPDATE_CONTRACT_ITEM_CREDIT_SUCCESS =
  "UPDATE_CONTRACT_ITEM_CREDIT_SUCCESS";
export const UPDATE_CONTRACT_ITEM_CREDIT_FAILURE =
  "UPDATE_CONTRACT_ITEM_CREDIT_FAILURE";

///contractitemcredit/delete
export const DELETE_CONTRACT_ITEM_CREDIT = "DELETE_CONTRACT_ITEM_CREDIT";
export const DELETE_CONTRACT_ITEM_CREDIT_SUCCESS =
  "DELETE_CONTRACT_ITEM_CREDIT_SUCCESS";
export const DELETE_CONTRACT_ITEM_CREDIT_FAILURE =
  "DELETE_CONTRACT_ITEM_CREDIT_FAILURE";

///contractitem/portfolio/timetracked
export const GET_CONTRACT_ITEM_PORTFOLIO = "GET_CONTRACT_ITEM_PORTFOLIO";
export const GET_CONTRACT_ITEM_PORTFOLIO_SUCCESS =
  "GET_CONTRACT_ITEM_PORTFOLIO_SUCCESS";
export const GET_CONTRACT_ITEM_PORTFOLIO_FAILURE =
  "GET_CONTRACT_ITEM_PORTFOLIO_FAILURE";

///contractitemdebit/list/(:num)
export const GET_CONTRACT_ITEM_DEBIT_LIST = "GET_CONTRACT_ITEM_DEBIT_LIST";
export const GET_CONTRACT_ITEM_DEBIT_LIST_SUCCESS =
  "GET_CONTRACT_ITEM_DEBIT_LIST_SUCCESS";
export const GET_CONTRACT_ITEM_DEBIT_LIST_FAILURE =
  "GET_CONTRACT_ITEM_DEBIT_LIST_FAILURE";

///job/listbycontractitem/(:num)
export const GET_JOB_LIST_BY_CONTRACT_ITEM = "GET_JOB_LIST_BY_CONTRACT_ITEM";
export const GET_JOB_LIST_BY_CONTRACT_ITEM_SUCCESS =
  "GET_JOB_LIST_BY_CONTRACT_ITEM_SUCCESS";
export const GET_JOB_LIST_BY_CONTRACT_ITEM_FAILURE =
  "GET_JOB_LIST_BY_CONTRACT_ITEM_FAILURE";